import React from "react";
import Sectitle from "../Title/Sectitle";
import Teamitem from "../Team/Teamitem";
import lang from "../../lang/lang";
const EbookdataBookDetail = () => {
  return (
    <section className="experts_team_area sec_pad" style={{marginTop:"50px"}}>
      <div className="container">
        <Sectitle
          sClass="sec_title text-center mb_70"
          Title={lang.S_EBOOK}
          tClass="t_color3"
          TitleP=""
        />
        <div className="row">
          <div className="col-lg-4 col-sm-6">
            <Teamitem
              teamImage="Ebook.png"
              memberN={lang.EbbokRelationship}
              memberd={0+ lang.P_Price}
            />
          </div>
          {/* <div className="col-lg-4 col-sm-6">
            <Teamitem
              teamImage="Menifistation.jpg"
              memberN="Menifistation"
              memberd="8 KWD"
            />
          </div>
          <div className="col-lg-4 col-sm-6">
            <Teamitem
              teamImage="Planning.jpg"
              memberN="Planning"
              memberd="8 KWD"
            />
          </div>
          <div className="col-lg-4 col-sm-6">
            <Teamitem
              teamImage="SelfLovePackage.jpg"
              memberN="Self Love Package"
              memberd="8 KWD"
            />
          </div>
          <div className="col-lg-4 col-sm-6">
            <Teamitem
              teamImage="Coaching.jpg"
              memberN="Coaching"
              memberd="8 KWD"
            />
          </div> */}
          {/* <div className="col-lg-4 col-sm-6">
            <Teamitem
              teamImage="ChakraBalancing.jpg"
              memberN="Chakra Balancing"
              memberd="8 KWD"
            />
          </div>
          <div className="col-lg-4 col-sm-6">
            <Teamitem
              teamImage="HealingRelationshipsMother.jpg"
              memberN="Healing Relationships With Mother
"
              memberd="8 KWD"
            />
          </div> */}
          {/* <div className="col-lg-4 col-sm-6">
                        <Teamitem teamImage="team_8.jpg" memberN="Bailey Wonger" memberd="Marketer"/>
                    </div>
                    <div className="col-lg-3 col-sm-6">
                        <Teamitem teamImage="team_9.jpg" memberN="Max Conversion" memberd="Social Marketer"/>
                    </div>
                    <div className="col-lg-3 col-sm-6">
                        <Teamitem teamImage="team_10.jpg" memberN="Jake Weary" memberd="UI/UX designer"/>
                    </div>
                    <div className="col-lg-3 col-sm-6">
                        <Teamitem teamImage="team_9.jpg" memberN="Justin Case" memberd="Marketer"/>
                    </div>
                    <div className="col-lg-3 col-sm-6">
                        <Teamitem teamImage="team_12.jpg" memberN="Norman Gordon" memberd="Web developer"/>
                    </div> */}
        </div>
      </div>
    </section>
  );
};
export default EbookdataBookDetail;
